/**
 * Login/ForgotPassword Controller
 *
 * 
 */

// the constructor for this object
function LoginForgotPasswordController() { }

// the object
LoginForgotPasswordController.prototype = {
    constructor: LoginForgotPasswordController,
    
    // initialize the controller
    init: function() 
    {
        PortalHelper.debugMessage('Forgot Password Controller Initialized');
    },
    
    // run the controller
    run: function()
    {
        // register the events used by this controller
        this._registerEvents();
        
        // turn on the submit button
        PortalHelper.enableButton('#forgot-password-button');
        
        PortalHelper.debugMessage('Forgot Password Controller Ran');
    },
    
    // register the javascript events
    _registerEvents:  function() 
    {   
        // handle the forgot password submit event
        $('#forgot-password-form').on('submit', function(e) {
            e.preventDefault();
            
            if($('#forgot-password-form').parsley().validate()) {
                
                var email = $('#forgot-password-form #email').val();
                
                // disable forgot password button while making request
                $(this).off('submit');
                PortalMain.LoginForgotPasswordController._forgotPassword(email);
            }
        });
    },
    
    // send the user a reset password email
    _forgotPassword: function(email) 
    {
        PortalHelper.loadingOverlay('#forgot-password-form', true);
        var forgotRequest = new PortalRequest;
        forgotRequest.errorElement = '#forgot-password-form .form-errors';
        forgotRequest.makeRequest(
            '/auth/forgot-password',
            {
                email: email,
            },
            function(data, code, message) {
                $('#forgot-password-form .form-success').removeClass('hidden');
            },
            function() {
                // re-enable forgot-password button
                PortalMain.LoginForgotPasswordController._registerEvents();
            }
        );
        PortalHelper.loadingOverlay('#forgot-password-form', false);
    },
    
}